import { render, staticRenderFns } from "./softDownload.vue?vue&type=template&id=6511ab07&scoped=true"
import script from "./softDownload.vue?vue&type=script&lang=js"
export * from "./softDownload.vue?vue&type=script&lang=js"
import style0 from "./softDownload.vue?vue&type=style&index=0&id=6511ab07&prod&scoped=true&lang=less"
import style1 from "./softDownload.vue?vue&type=style&index=1&id=6511ab07&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6511ab07",
  null
  
)

export default component.exports